import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';

import Loader from '~components/loader';
import { Message, MessageTyping } from './message';

import './style.scss';

const Messages = ({
  participants,
  messages,
  createdAt,
  className,
  onScrollEnd,
  isLoading,
  scrollTo,
  forceScroll,
  peerId,
  isPeerWriting,
  seenByPeerAt,
  personId,
  discussion,
  recipient,
}) => {
  const intl = useIntl();
  const [currentScrollTop, setCurrentScrollTop] = useState(0);

  const messagesRef = useRef();

  useEffect(() => {
    if (!isLoading && messages && messagesRef.current && currentScrollTop !== 0 && scrollTo === 'top') {
      messagesRef.current.scrollTo(0, currentScrollTop);
    }
  }, [messages]);

  useEffect(() => {
    if (forceScroll && messagesRef.current && forceScroll === 'top') {
      messagesRef.current.scrollTo(0, 0);
      return;
    }
    if (forceScroll && messagesRef.current && forceScroll === 'bottom') {
      messagesRef.current.scrollTo(0, messagesRef.current.scrollHeight);
    }
  }, [forceScroll]);

  const onScroll = () => {
    if (messagesRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = messagesRef.current;
      if (scrollHeight + scrollTop <= clientHeight && !isLoading) {
        onScrollEnd();
        setCurrentScrollTop(scrollTop);
      }
    }
  };

  return (
    <div
      className={className}
      ref={messagesRef}
      onScroll={onScroll}
    >
      {messages && messages.length > 0 ? (
        <>
          <div
            className="c-chat__messages"
            role="log"
            aria-live="polite"
            aria-label={intl.formatMessage({ id: 'components.chat.messages-region', defaultMessage: 'Chat messages' })}
          >
            {messages.map((msg) => {
              return (
                <Message
                  key={msg.messageId}
                  body={msg.body}
                  createdAt={msg.createdAt}
                  sender={msg.personId === personId ? participants.currentUser : participants.recipient}
                  isReversed={msg.personId !== personId}
                  isDelivered={
                    msg.personId === personId && (typeof msg.isDelivered === 'undefined' || msg.isDelivered === true)
                  }
                  isSeen={msg.personId === personId && (msg.isSeen || (seenByPeerAt && msg.createdAt <= seenByPeerAt))}
                  isSending={msg.isSending}
                />
              );
            })}
            {isPeerWriting && <MessageTyping sender={participants.recipient} />}
          </div>
          <div className="c-chat__beginning">
            {intl.formatMessage(
              { id: 'components.chat.start-date', defaultMessage: 'Chat started on {date}' },
              {
                date: intl.formatDate(moment.unix(createdAt).toDate(), {
                  hour: 'numeric',
                  minute: 'numeric',
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                }),
              }
            )}
            <p style={{ padding: '10px 12px', textTransform: 'capitalize', color: discussion?.acceptanceState === 'rejected' ? 'red' : discussion?.acceptanceState === 'accepted' ? 'green' : 'orange' }}>
              {discussion?.acceptanceState || recipient?.status}
            </p>
            {isLoading && (
              <div className="c-chat__messages-loader">
                <Loader />
              </div>
            )}
          </div>
        </>
      ) : (
        <>
        <div className="c-chat__beginning">
            <p style={{ padding: '10px 12px', textTransform: 'capitalize', color: discussion?.acceptanceState === 'rejected' ? 'red' : discussion?.acceptanceState === 'accepted' ? 'green' : 'orange' }}>
              {discussion?.acceptanceState || recipient?.status}
            </p>
            {isLoading && (
              <div className="c-chat__messages-loader">
                <Loader />
              </div>
            )}
          </div>
        <div className="c-chat__no-messages">
          {intl.formatMessage({ id: 'components.chat.no-messages', defaultMessage: 'Write a message' })}
        </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Messages);
